import React from 'react';
import { RequestStatus, ScreenType } from "Constants";
import ReservationService from 'Services/reservation.service';
import "./styles.sass";

// @ts-ignore
import { LocalizationContext } from "react-localize";
import MvLink from 'Generic/MvLink';
import MvIcon from 'Generic/MvIcon';
import moment from 'moment';
// @ts-ignore
import sessionStorage from 'store/storages/sessionStorage';
import BookingInfo from '../ApplyYourPoints/BookingInfo';
import StayPreferences from '../Summary/StayPreferences';
import GuestProfile from '../Summary/GuestProfile';
import { AdditionalGuestProfile } from '../Summary/AdditionalGuestProfile';
import { GuestDetail, GuestEmail } from '../Summary/AdditionalGuestProfile/AdditionalGuestProfile';
import { UsageDetails } from '../Summary/UsageDetails';
import { MvTermsConditions } from 'Generic/MvTermsConditions';
import { MvPrimaryBtn } from 'Generic/MvPrimaryBtn';
import { BookResortResult, Term, ReservationResult } from 'Interfaces/BookResort';
import { SelectedPreferences } from '../Summary/Review/Review';
import { ContractUsage, Preferences, ReservationDetails, ReservationViewFields, showReservationField, SiteType } from 'Interfaces/AYPResultInterface';
import { ReservationType } from 'Interfaces/GetReservations';
import MvLoader from 'Generic/MvLoader/MvLoader';
import { OwnerContract, OwnerShipDetails } from 'Interfaces/OwnerInterface';
import ContractToolTip from 'Interfaces/ContractToolTipInterface';
import MvContractToolTip from 'Generic/ToolTip/MvContractToolTip';
import ToolTip, { Position } from 'Generic/ToolTip/ToolTip';
import { RequestError } from 'Interfaces/RequestError';
import { PromoSection } from 'Generic/PromoSection';
import { GetAdsResponse } from 'Interfaces/AdsInterface';
import { ReactAppMode } from "Interfaces/ReactAppModes";
import { EXEC_MODE } from "cfg";

type Props = {
    token: string;
    lang: string;
    resId: number;
    resType: ReservationType;
    setScreenType(screenType: ScreenType): void;
    apiTimeout: string;
};

type State = {
    reservation: ReservationResult;
    dataStatus: RequestStatus;
    selectedPreferences: SelectedPreferences;
    contractToolTips: ContractToolTip[];
    setUsageDetailsTableOpen: number;
    ads: GetAdsResponse;
}

const InitState: State = {
    reservation: {} as ReservationResult,
    dataStatus: RequestStatus.LOADING,
    selectedPreferences: {
        roomRequests: {},
        additionalRequests: '',
    },
    contractToolTips: [],
    setUsageDetailsTableOpen: 0,
    ads: [],
}

class ViewReservation extends React.Component<Props, State> {
    reservationService: ReservationService;
    _isMounted: boolean;

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = Object.assign({}, InitState);
        this.reservationService = new ReservationService();
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        this.reservationService.getReservation(this.props.resId, this.props.resType).then(reservation => {
            console.log({ reservation })
            this.setState({
                reservation: reservation as ReservationResult,
                dataStatus: RequestStatus.LOADED
            }, () => {
                this.loadSelectedPreferences();
                const contractList = this.getUsageContractDetails();
                this.fetchContactTooltips(contractList);
            });
        });

        // get promos for some reservation that is happening in the future time
        this.reservationService.getAds().then(ads => {
            this.setState({ ads });
        });
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }

    loadSelectedPreferences = () => {
        const { preferences } = this.state.reservation;

        // check for selected preferences in session
        let selectedPreferences = JSON.parse(sessionStorage.read(ReservationService.SELECTED_PREFERENCES));

        // if no selected preferences in session, set empty preferences with default selections
        if (!selectedPreferences) {
            selectedPreferences = { ...this.state.selectedPreferences };

            (preferences as Preferences).map(preference => {
                preference.options.map(option => {
                    if (option.default) {
                        selectedPreferences = {
                            ...selectedPreferences,
                            roomRequests: {
                                ...selectedPreferences.roomRequests,
                                [preference.code]: option.code,
                            },
                        };
                    }
                })
            });
        }

        this.setState({ selectedPreferences });
    }


    termFilter = (term: Term) => {
        // don't show email term if no emails are entered that are valid
        if (this.state.reservation && this.state.reservation.additionalEmails && this.state.reservation.additionalEmails.length === 0) {
            return term.type !== 'terms-additional-emails'
        }

        return true;
    };

    handleOwnershipSummaryClick = () => {
        if ([ReactAppMode.VCAP].includes(EXEC_MODE)) {
            window.open(`/checkpoints.jsp`, '_self');
        } else {
            window.open(`/timeshare/mvco/getProductSummary`, '_self');
        }
    }

    handleReservationActivityClick = () => {
        if ([ReactAppMode.VCAP].includes(EXEC_MODE)) {
            if (this.props.resType === ReservationType.CANCELED) {
                localStorage.setItem(`${ScreenType.RESERVATIONS}-tab`, ReservationType.CANCELED);
            }
            window.open(`/reservationActivity.jsp`, '_self');
        } else {
            if (this.props.resType === ReservationType.CANCELED) {
                localStorage.setItem(`${ScreenType.RESERVATIONS}-tab`, ReservationType.CANCELED);
            }
            this.props.setScreenType(ScreenType.RESERVATIONS);
        }
    }

    getHeader(): string {
        const { localize } = this.context;
        let header = "";
        switch (this.props.resType) {
            case ReservationType.UPCOMING:
                header = localize("Upcoming Reservation");
                //header = localize("static.content.view-res-header-upcoming");
                break;
            case ReservationType.PAST:
                header = localize("Past Reservation");
                //header = localize("static.content.view-res-header-past");
                break;
            case ReservationType.CANCELED:
                header = localize("Cancelled Reservation");
                //header = localize("static.content.view-res-header-canceled");
                break;
        }
        return header;
    }

    getNumberLabel(): string {
        const { localize } = this.context;
        let label = "";
        switch (this.props.resType) {
            case ReservationType.UPCOMING:
                label = localize("Confirmation #");
                //label = localize("static.content.view-res-confirmation-num");
                break;
            case ReservationType.PAST:
                label = localize("Reservation #");
                //label = localize("static.content.view-res-reservation-num");
                break;
            case ReservationType.CANCELED:
                label = localize("static.content.reservations-reservation-num");
                break;
        }
        return label + ":";
    }

    getNumberContent(): string {
        const hopperReservation = (this.state.reservation.reservationDetails && this.state.reservation.reservationDetails.managementCompany && (this.state.reservation.reservationDetails.managementCompany.siteType === SiteType.EXPLORER) && (this.state.reservation.reservationDetails.managementCompany.nodename === 'hopper'));
        let content = "";
        const reservationConfirmationNum = this.state.reservation.reservationConfirmationNumber;
        switch (this.props.resType) {
            case ReservationType.UPCOMING:
                content = this.state.reservation.reservationConfirmationNumber;
                break;
            case ReservationType.PAST:
                content = hopperReservation ? reservationConfirmationNum : this.state.reservation.reservationNumber;
                break;
            case ReservationType.CANCELED:
                content = hopperReservation ? reservationConfirmationNum : this.state.reservation.reservationNumber;
                break;
        }
        return content;
    }

    getDateLabel(): string {
        const { localize } = this.context;
        let label = "";
        switch (this.props.resType) {
            case ReservationType.UPCOMING:
            case ReservationType.PAST:
                label = localize("Transaction Date")
                // label = localize("static.content.view-res-trans-date")
                break;
            case ReservationType.CANCELED:
                label = localize("Cancel Date")
                // label = localize("static.content.view-res-cancel-date")
                break;
        }
        return label + ":";
    }

    getDateContent(): string {
        let content = "";
        switch (this.props.resType) {
            case ReservationType.UPCOMING:
            case ReservationType.PAST:
                content = this.state.reservation.transactionDate ? moment(this.state.reservation.transactionDate).format("D MMM YYYY") : "";
                break;
            case ReservationType.CANCELED:
                content = this.state.reservation.cancelDate ? moment(this.state.reservation.cancelDate).format("D MMM YYYY") : "";
                break;
        }
        return content;
    }

    getUsageContractDetails = (): ContractUsage[] => {
        const usageDetails = this.state.reservation.usageDetails;
        const contractDetails: ContractUsage[] = [];
        if (usageDetails && usageDetails.usage && usageDetails.usage.length > 0) {
            usageDetails.usage.forEach(item => {
                contractDetails.push({ contractId: item.contractId,contractNumber:item.contractNumber, usageType: item.type, usageYear: item.year, appliedPoints: item.applied } as ContractUsage);
            });
        }
        if (usageDetails && usageDetails.borrowedUsage && usageDetails.borrowedUsage.length > 0) {
            usageDetails.borrowedUsage.forEach(item => {
                contractDetails.push({ borrowChecked: true, contractId: item.contractId,contractNumber:item.contractNumber, usageType: item.type, usageYear: item.year, appliedPoints: item.applied } as ContractUsage);
            });
        }
        if (usageDetails && usageDetails.refundUsage && usageDetails.refundUsage.length > 0) {
            usageDetails.refundUsage.forEach(item => {
                contractDetails.push({ refundChecked: true, contractId: item.contractId,contractNumber:item.contractNumber,usageType: item.type, usageYear: item.year, appliedPoints: item.applied, startDate: item.startDate, endDate: item.endDate, description: item.description } as ContractUsage);
            });
        }
        if (usageDetails && usageDetails.refundedNormalUsageTypes && usageDetails.refundedNormalUsageTypes.length > 0) {
            usageDetails.refundedNormalUsageTypes.forEach((item: any) => {
                contractDetails.push({ contractId: item.contractId,contractNumber:item.contractNumber, refundChecked: true, usageType: item.type, usageYear: item.year, appliedPoints: item.applied, startDate: item.startDate, endDate: item.endDate, description: item.description } as unknown as ContractUsage);
            });
        }
        if (usageDetails && usageDetails.refundedHoldUsageTypes && usageDetails.refundedHoldUsageTypes.length > 0) {
            usageDetails.refundedHoldUsageTypes.forEach((item: any) => {
                contractDetails.push({ contractId: item.contractId, contractNumber:item.contractNumber,refundChecked: true, usageType: item.type, usageYear: item.year, appliedPoints: item.applied, startDate: item.startDate, endDate: item.endDate, description: item.description } as unknown as ContractUsage);
            });
        }
        if (usageDetails && usageDetails.refundedForefeitUsageTypes && usageDetails.refundedForefeitUsageTypes.length > 0) {
            usageDetails.refundedForefeitUsageTypes.forEach((item: any) => {
                contractDetails.push({ contractId: item.contractId,contractNumber:item.contractNumber, refundChecked: true, usageType: item.type, usageYear: item.year, appliedPoints: item.applied, startDate: item.startDate, endDate: item.endDate, description: item.description } as unknown as ContractUsage);
            });
          }
        return contractDetails;
    }

    convertOCtoCTT = (oc: OwnerContract): ContractToolTip => {
        // the AYP table is still returning mock data? that will be returning real
        //  data this sprint by Rama - done by tomorrow perhaps
        // getting CORS error
        return {
            id: oc.id,
            contractId: String(oc.id),
            contractNumber: oc.contractNumber,
            contractType: oc.contractType,
            // hard code to points for now
            // the service is not providing this field 
            // it is also not returning any weeks data
            typeName: "points",
            startDate: oc.contractStartDate,
            endDate: oc.contractEndDate,
            // this field is missing from the service
            // it is being looked into
            // so for now, just show the start date's year
            usageYear: oc.contractStartDate,
            points: oc.contractPoints,
            ownershipDetails: oc.ownershipDetails
                ? oc.ownershipDetails
                : ({} as OwnerShipDetails)
            
        };
    }

    /**
    * Converts the contract info into a ContracToolTip
    */
    getContractToolTipJSX(contractToolTip: ContractToolTip): any {
        const contractId = contractToolTip.contractId;
        const key =
          contractId +
          contractToolTip.startDate +
          contractToolTip.endDate +
          (contractToolTip.points ? contractToolTip.points.toString() : "");
        const contractIdStyle = (
          <p
            key={key}
            className="contract-id mv-print-link"
            aria-label={contractId}
            style={{ textDecoration: 'underline' }}
          >
            {contractToolTip.contractNumber}
          </p>
        );
    
        return (
          <MvContractToolTip contract={contractToolTip} position={Position.RIGHT}>
            {contractIdStyle}
          </MvContractToolTip>
        );
    }

    /**
   * Gets and stores the contract tooltip data for all contracts
   */
    fetchContactTooltips = (contracts: ContractUsage[]) => {
        return new Promise((resolve, reject) => {
            // get a unique list of contract Ids
            const contractList: any = new Set(contracts.map(usages => usages.contractId));

            // get the contracts' data
            this.reservationService.getOwnerContracts(contractList)
                .then((ownerContracts: OwnerContract[]) => {

                    // build the ContractToolTip[]
                    let contractToolTips: ContractToolTip[] = [];
                    ownerContracts.map(contract => {
                        // convert OwnerContract to ContractToolTip
                        let tempContractToolTip = this.convertOCtoCTT(contract);
                        // get the tooltip jsx
                        tempContractToolTip.toolTip = this.getContractToolTipJSX(tempContractToolTip);
                        contractToolTips.push(tempContractToolTip);
                    });

                    if (this._isMounted) {
                        this.setState({
                            contractToolTips
                        });
                    }
                    resolve();
                })
                .catch((error: RequestError) => {
                    reject(error);
                });
        });
    }

    print = () => {
        this.setState({
            setUsageDetailsTableOpen: Math.floor(Math.random() * 10000),
        }, () => {
            window.print();
        });
    };

    showResField(resViewField: ReservationViewFields) {
        return showReservationField(resViewField, this.state.reservation.reservationDetails);
    }

    render() {
        const { localize } = this.context;
        const isLoading = this.state.dataStatus === RequestStatus.LOADING;
        const showGuestProfile = this.showResField(ReservationViewFields.GUEST_INFO) &&
            (
                this.showResField(ReservationViewFields.PRIMARY_GUEST) ||
                this.showResField(ReservationViewFields.ADDITIONAL_GUESTS)
            )
        const showImportantInfo =
            this.state.reservation.reservationDetails &&
            this.state.reservation.reservationDetails.managementCompany &&
            this.state.reservation.reservationDetails.managementCompany.siteType === SiteType.MVC;

        console.log({ viewReservation_render: { "reservation": this.state.reservation, "contractToolTips": this.state.contractToolTips } })

        const usageDetailContent =
            <UsageDetails
                contracts={this.getUsageContractDetails()}
                contractToolTips={this.state.contractToolTips}
                onContractsSort={() => { }}
                onEditClick={() => { }}
                readOnly={true}
                setTablesOpen={this.state.setUsageDetailsTableOpen}
                tablesInitOpen={true}
                tablesExpandable={true}
                resType={this.props.resType}
                appliedPoints={this.state.reservation && this.state.reservation.usageDetails ? this.state.reservation.usageDetails.appliedPoints : 0}
                apiTimeout = {this.props.apiTimeout}
            />

        const resDetailsResType = sessionStorage.read("reservationType");
        const showPointsNeeded = resDetailsResType !== "Premier Vacation";
        const usageSummaryContent =  <div className="ownership-summary">
        <p className="summary-header">{localize("static.content.ownership-usage-summary-header")}</p>
        <div className="summary-container">
          {this.state.reservation.usageDetails &&
            this.state.reservation.usageDetails.appliedPoints >
              0 && (
              <div className="summary-items first">
                <div className="summary-items-label">
                {localize("static.content.originally-applied-label")}{" "}
                </div>
                <div className="summary-items-value">
                  {
                    this.state.reservation.usageDetails.appliedPoints
                  }{" "}
                  Points
                </div>
              </div>
            )}
          {this.state.reservation.usageDetails &&
            (this.state.reservation.usageDetails.totalPointsReturned || 0) > 0 && (
              <div className="summary-items">
                <div className="summary-items-label">
                  <div>{localize("static.content.refunded-to-you-label")}</div>
                  <ToolTip
                    useRefToPosition={false}
                    tip={[
                      {
                        label: "",
                        desc:
                          "Club Points are returned unrestricted when canceled 61 days or more prior to arrival.",
                      },
                    ]}
                    id="points-needed"
                  >
                    <span className="question-icon">{"?"}</span>
                  </ToolTip>
                </div>
                <div className="summary-items-value">
                  {
                    this.state.reservation.usageDetails.totalPointsReturned
                  }{" "}
                  {localize("static.content.points-label")}
                </div>
              </div>
            )}
          {this.state.reservation.usageDetails &&
            (this.state.reservation.usageDetails.holdPoints || 0) >
              0 && (
              <div className="summary-items">
                <div className="summary-items-label">
                  <div>{localize("static.content.refunded-to-hold-label")}</div>
                  <ToolTip
                    useRefToPosition={false}
                    tip={[
                      {
                        label: "",
                        desc:
                          "Club Points in a holding account may be used to confirm another reservation within 60 days of arrival.",
                      },
                    ]}
                    id="points-needed"
                  >
                    <span className="question-icon">{"?"}</span>
                  </ToolTip>
                </div>
                <div className="summary-items-value">
                  {
                    this.state.reservation.usageDetails.holdPoints
                  }{" "}
                  Points
                </div>
              </div>
            )}
          {this.state.reservation.usageDetails &&
            (this.state.reservation.usageDetails.forefeitPoints || 0) >
              0 && (
              <div className="summary-items">
                <div className="summary-items-label">
                  <div>{localize("static.content.forfeited-label")}</div>
                  <ToolTip
                    useRefToPosition={false}
                    tip={[
                      {
                        label: "",
                        desc:
                          "Premium Points are forfeited on reservation canceled within 60 days of arrival.",
                      },
                    ]}
                    id="points-needed"
                  >
                    <span className="question-icon">{"?"}</span>
                  </ToolTip>
                </div>
                <div className="summary-items-value">
                  -
                  {
                    this.state.reservation.usageDetails.forefeitPoints
                  }{" "}
                  Points
                </div>
              </div>
            )}
        </div>
      </div>

        return (
            <div className='view-reservation-page'>
                <div className="page-header">
                    <div className="page-header-links">

                        <MvLink label='Ownership Summary' onClick={this.handleOwnershipSummaryClick} />
                        <MvLink label='Reservation Activity' onClick={this.handleReservationActivityClick} />
                    </div>

                    <div>
                        <h1>
                            {" "}
                            {this.getHeader()}
                        </h1>
                        <button className='print-container' onClick={this.print}>
                            <MvIcon
                                color="#5F5F5F"
                                style={{
                                    height: "14px",
                                    width: "14px"
                                }}
                                icon={"print"}
                            />
                            {/* <p>{localize("static.content.view-res-print")}</p> */}
                            <p>{localize("Print")}</p>
                        </button>
                    </div>
                </div>
                <div className={`loader-container ${isLoading ? "loading" : ""}`}>
                    <MvLoader show={isLoading}>
                        <div className="details-container">
                            <div className="details-label">
                                {this.getDateLabel()}&nbsp;
                                {this.getDateContent()}
                            </div>
                            <div className="details-label">
                                {this.getNumberLabel()}&nbsp;
                                {this.getNumberContent()}
                            </div>
                        </div>
                        {this.state.reservation.reservationDetails && <BookingInfo
                            comingFrom="viewReservation"
                            resType={this.props.resType}
                            resId={this.props.resId}
                            reservationDetails={this.state.reservation.reservationDetails}
                            pointsRequired={this.state.reservation.usageDetails.appliedPoints}
                            onEditSearchClick={() => { }}
                            readOnly={true}
                            canCancel={this.state.reservation.canCancel}
                            setScreenType={this.props.setScreenType}
                            reservationData={this.state.reservation}
                        />}
                         {this.props.resType === ReservationType.CANCELED && usageSummaryContent}
                        {this.state.reservation.preferences && <div className='border-container'>
                            {this.props.resType === ReservationType.CANCELED && showPointsNeeded && usageDetailContent}
                            {this.state.reservation.preferences.length && <StayPreferences
                                selectedPreferences={this.state.selectedPreferences}
                                preferenceOptions={this.state.reservation.preferences}
                                updateStayPreferences={() => { }}
                                optionsLoading={false}
                                readOnly={true}
                            /> || null}
                            {console.log('reservation---------------', this.state.reservation.reservationDetails)}
                            {console.log("management................", this.state.reservation && this.state.reservation.reservationDetails)}
                            {showGuestProfile && <>
                                <GuestProfile
                                    guest={this.state.reservation.primaryGuest}
                                    readOnly={true}
                                    showPrimaryGuest={this.showResField(ReservationViewFields.PRIMARY_GUEST)}
                                    resType={this.props.resType}
                                    resID={this.props.resId}
                                    reservationCheckIn={this.state.reservation.reservationDetails.checkInDate}
                                    reservationType={this.state.reservation.reservationType}
                                    reservationInformation={this.state.reservation.reservationDetails}
                                />
                                {(this.state.reservation.reservationDetails.managementCompany && (this.state.reservation.reservationDetails.managementCompany.siteType !== SiteType.EXPLORER) && (this.state.reservation.reservationDetails.managementCompany.nodename !== 'hopper')) &&
                                <AdditionalGuestProfile
                                    readonly={true}
                                    additionalGuests={(this.state.reservation.additionalGuests || []).filter(x => !!x.firstName)}
                                    emails={(this.state.reservation.additionalEmails || []).filter(x => !!x).map(x => ({ email: x } as GuestEmail))}
                                    showAdditionalGuests={this.showResField(ReservationViewFields.ADDITIONAL_GUESTS)}
                                    showEmails={false}
                                />}
                            </>}
                            {this.props.resType !== ReservationType.CANCELED && showPointsNeeded && usageDetailContent}
                        </div>}
                        {this.state.ads && this.state.ads.length > 0 && this.props.resType === ReservationType.UPCOMING &&
                            <PromoSection
                                promos={this.state.ads.map(ad => ({
                                    image: ad.image,
                                    url: ad.url
                                }))}
                            />
                        }
                    </MvLoader>
                </div>
            </div>
        );
    }

};

ViewReservation.contextType = LocalizationContext;
export {
    ViewReservation,
};